import api from '../../../services/api';
import { useState, useEffect } from "react";
import { Link, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import ArrowCircleUpOutlinedIcon from '@mui/icons-material/ArrowCircleUpOutlined';
import ArrowCircleDownOutlinedIcon from '@mui/icons-material/ArrowCircleDownOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PageContainer from '../../../common/components/PageContainer';
import PageHeader from '../../../common/components/PageHeader';
import usePermissoes from '../../../common/hooks/usePermissoes';
import Permissoes from '../../../common/permissoes';

function EPIOpcoes() {
    const { hasPermission } = usePermissoes();
    const podeGerenciar = hasPermission(Permissoes.EPI_CADASTRO);
    const [item, setItem] = useState({});
    const { id } = useParams();

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get(`/epi/${id}`);
                setItem(response.data);
            } catch (error) {
                console.error('Erro ao buscar o item:', error);
            }
        }
        fetchData();
    }, [id]);

    const opcoes = podeGerenciar
        ? [
            { label: 'Entrada', to: `/epi/${item.id}/entrada`, icon: <ArrowCircleUpOutlinedIcon color="secondary" sx={{ fontSize: 40 }} /> },
            { label: 'Saída', to: `/epi/${item.id}/saida`, icon: <ArrowCircleDownOutlinedIcon color="error" sx={{ fontSize: 40 }} /> },
            { label: 'Editar item', to: `/epi/${item.id}/editar`, icon: <EditOutlinedIcon color="primary" sx={{ fontSize: 40 }} /> },
        ]
        : [];

    return (
        <PageContainer>
            <PageHeader title={`${item.nome || ''}: ${item.estoque ?? ''} Unidades`} />

            {item.foto && (
                <Box
                    component="img"
                    src={`data:image/jpeg;base64,${item.foto}`}
                    alt="Item"
                    sx={{ width: '100%', maxHeight: 260, objectFit: 'cover', borderRadius: 2, mb: 3 }}
                />
            )}

            {opcoes.length > 0 ? (
                <Grid container spacing={2}>
                    {opcoes.map((opcao) => (
                        <Grid item xs={12} sm={6} md={4} key={opcao.label}>
                            <Card>
                                <CardActionArea component={Link} to={opcao.to} sx={{ p: 3 }}>
                                    <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                        {opcao.icon}
                                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{opcao.label}</Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            ) : (
                <Typography color="text.secondary">
                    Você não tem permissão para movimentar ou editar este item.
                </Typography>
            )}
        </PageContainer>
    );
}

export default EPIOpcoes;
